import React, { useMemo } from 'react'
import LineGraphSummary from './LineGraphSummary'
import { useQuery } from '@tanstack/react-query';
import { getMonthlyHitsSummary, getWeeklyHitsSummary } from '../../../services/finance/payments-service';
import { Alert, Spinner } from 'react-bootstrap';
import { DASHBOARD_REFETCH_INTERVAL_MS } from './constants';

function HitsGraphWidget({ period }) {
    const queryFn = period === 'Monthly' ? getMonthlyHitsSummary : getWeeklyHitsSummary;

    const { isLoading, isError, error, data: hits } = useQuery({
        queryKey: ["finance", "hitsummary", period],
        queryFn: () => queryFn(),
        refetchInterval: DASHBOARD_REFETCH_INTERVAL_MS,
        refetchIntervalInBackground: false
    });

    const { labels, data } = useMemo(() => {
        const labels_list = [];
        const value_list = [];
        for (const item in hits?.data ?? {}) {
            labels_list.push(hits.data[item].label);
            value_list.push(hits.data[item].total);
        }
        return { labels: labels_list, data: value_list };
    }, [hits]);

  return (
    <div>
        {isLoading ? (
            <Spinner />
          ) : isError ? (
            <Alert variant='danger'>Error: {error.message}</Alert>
          ) : (
                <LineGraphSummary labels={labels} data={data} title={`${period} Hits by Period`} />
          )}
    </div>
  )
}

export default HitsGraphWidget
